import { HugeiconsIcon, IconSvgElement } from "@hugeicons/react";
import { ReactNode } from "react";
import { cx } from "shared/utils";

export const ActionLabel = ({
  icon,
  label,
  iconClassName = "text-content-200",
  rightElement
}: {
  icon: IconSvgElement;
  label: string;
  iconClassName?: string;
  rightElement?: ReactNode;
}) => (
  <span
    className={cx("flex gap-3 py-0.5 items-center", rightElement && "w-full")}
  >
    <HugeiconsIcon icon={icon} size={20} className={iconClassName} />
    <span>{label}</span>
    {rightElement ? <span className="ml-auto">{rightElement}</span> : null}
  </span>
);
